import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateShopWorkflowLogistician(shopId: string) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation("patch", "/shops-workflowlogistician/{shopId}/workflowlogistician", {
    invalidate: invalidateShop,
    mapVariables: (activated: boolean) => ({
      params: { path: { shopId } },
      body: {
        activated,
      },
    }),
  });
}
